import { Stack, IconButton, Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";

export const getHeaderConfig = (handleClick, userOptions = []) => {
  const getUserName = (userId) => {
    if (!userId) return "-";
    const found = userOptions.find((o) => +o.value === +userId);
    return found ? found.label : `ID:${userId}`;
  };

  const headerConfig = [
    {
      label: "Step",
      id: "stepNumber",
      render: (data) => `Step ${data.stepNumber}`,
    },
    {
      label: "Name",
      id: "name",
    },
    {
      label: "Approver Type",
      id: "approverType",
      render: (data) => {
        if (data.approverType === "ROLE") {
          return (
            <span style={{ fontWeight: "bold" }}>
              ROLE ({data?.approverRole?.join(", ") || "-"})
            </span>
          );
        }
        if (data.approverType === "REGIONAL_USER") {
          const mappings = (data.regionalApprovers || []);
          if (!mappings.length) return <span>Regional User (none)</span>;
          return (
            <Box>
              {mappings.map((ra, i) => (
                <div key={i} style={{ fontSize: "0.82rem" }}>
                  <strong>{ra.region}</strong>: {getUserName(ra.approverUserId)}
                </div>
              ))}
            </Box>
          );
        }
        const userIds = [...new Set([data?.approverUserId, ...(data?.approverUserIds || [])].filter((id) => id != null && id !== ""))];
        return <span>USER ({userIds.map((id) => getUserName(id)).join(", ")})</span>;
      },
    },
    {
      label: "Routing Rules",
      id: "routing",
      render: (data) => {
        const rules = [];
        if (data.canSendBackTo && data.canSendBackTo.length > 0) {
          rules.push(`Choose: ${data.canSendBackTo.join(", ")}`);
        }
        return <span>{rules.length > 0 ? rules.join(" | ") : "—"}</span>;
      },
    },
    {
      label: "Editable Files",
      id: "editableFilesObject",
      render: (data) => {
        const obj = data.editableFilesObject || {};
        if (!Object.keys(obj).length) return <span>—</span>;
        return (
          <span style={{ wordBreak: "break-all" }}>{JSON.stringify(obj)}</span>
        );
      },
    },
    {
      label: "CF Status",
      id: "cfStatus",
    },
    {
      label: "Reminders",
      id: "reminders",
      render: (data) => (
        <Box sx={{ fontSize: "0.82rem" }}>
          <div>
            {data.reminderHours ?? "default"}h × {data.maxReminders ?? "default"}
          </div>
          {data.autoApproveAfterStale && (
            <span style={{ color: "#b26a00", fontWeight: "bold" }}>
              Auto-approves {data.autoApproveHours ?? "default"}h after last reminder
            </span>
          )}
        </Box>
      ),
    },
    {
      label: "Actions",
      id: "actions",
      render: (data, onClick) => {
        return (
          <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
            <IconButton
              sx={{ p: 0 }}
              onClick={() => handleClick(data, "EDIT")}
              title="Edit step configuration"
            >
              <EditIcon />
            </IconButton>
            <IconButton
              sx={{ p: 0 }}
              onClick={() => handleClick(data, "VIEW")}
              title="View details"
            >
              <InfoIcon />
            </IconButton>
          </Box>
        );
      },
    },
  ];
  return headerConfig;
};
